/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    size: {
      type: 'variant',
      values: [ 'micro', 'small', 'medium', 'large' ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { size: 'large' },
      tokens: {
        amountFontSize: 72,
        bottomTextFontSize: 18,
        bottomTextLineHeight: 1.55555555,
        centsFontSize: 48,
        centsLineHeight: 0.975,
        currencySymbolFontSize: 48,
        currencySymbolLineHeight: 1,
        rateFontName: 'SofiaPro',
        rateFontSize: 20,
        rateFontWeight: '700',
        rateLineHeight: 1.25,
        strikeThroughHeight: 3,
        strikeThroughPosition: 33,
        topTextFontSize: 18,
        topTextLineHeight: 1.55555555
      }
    },
    {
      if: { size: 'large', viewport: [ 'lg', 'xl' ] },
      tokens: {
        bottomTextFontSize: 20,
        bottomTextLineHeight: 1.4,
        topTextFontSize: 20,
        topTextLineHeight: 1.4
      }
    },
    {
      if: { size: 'micro' },
      tokens: {
        amountFontSize: 36,
        bottomTextFontSize: 16,
        bottomTextLineHeight: 1.5,
        centsFontSize: 18,
        centsLineHeight: 0.975,
        currencySymbolFontSize: 18,
        currencySymbolLineHeight: 1.2,
        rateFontName: 'SofiaPro',
        rateFontSize: 16,
        rateFontWeight: '700',
        rateLineHeight: 1.25,
        strikeThroughPosition: 16,
        topTextFontSize: 16,
        topTextLineHeight: 1.5
      }
    },
    {
      if: { size: 'small' },
      tokens: {
        amountFontSize: 36,
        bottomTextFontSize: 16,
        bottomTextLineHeight: 1.5,
        centsFontSize: 18,
        centsLineHeight: 0.975,
        currencySymbolFontSize: 18,
        currencySymbolLineHeight: 1.2,
        rateFontName: 'SofiaPro',
        rateFontSize: 16,
        rateFontWeight: '700',
        rateLineHeight: 1.25,
        strikeThroughPosition: 16,
        topTextFontSize: 16,
        topTextLineHeight: 1.5
      }
    }
  ],
  tokens: {
    alignItemsText: 'flex-start',
    amountFontName: 'BystanderSans',
    amountFontSize: 48,
    amountFontWeight: '700',
    amountLetterSpacing: -0.039,
    amountLineHeight: 0.75,
    bottomLinksMarginLeft: 4,
    bottomTextFontSize: 18,
    bottomTextLineHeight: 1.55555555,
    bottomTextMarginTop: 0,
    centsFontName: 'BystanderSans',
    centsFontSize: 20,
    centsFontWeight: '700',
    centsLineHeight: 1.2,
    centsPaddingTop: 0,
    currencySymbolFontName: 'BystanderSans',
    currencySymbolFontSize: 20,
    currencySymbolFontWeight: '700',
    currencySymbolLineHeight: 1.2,
    currencySymbolPaddingTop: 0,
    dividerColor: null,
    fontColor: '#394056',
    fontName: 'SofiaPro',
    fontWeight: '700',
    footnoteGap: 4,
    footnoteLinkColor: '#636c8c',
    footnoteLinkFontName: 'SofiaPro',
    footnoteLinkFontSize: 16,
    footnoteLinkFontWeight: '700',
    footnoteLinkLineHeight: 1.4285714285714286,
    footnoteMarginTop: 0,
    priceMarginBottom: 4,
    rateFontName: 'SofiaPro',
    rateFontSize: 18,
    rateFontWeight: '700',
    rateLineHeight: 1.25,
    strikeThroughColor: '#394056',
    strikeThroughHeight: 2,
    strikeThroughPosition: 22,
    topTextFontName: 'SofiaPro',
    topTextFontSize: 18,
    topTextFontWeight: '700',
    topTextLineHeight: 1.55555555,
    topTextMarginBottom: 4
  }
}
export default theme
